import React, { Component } from "react";

import axios from "@app/lib/axios";
import { format } from "date-fns";

import * as util from "@app/lib/utility";
import * as commonData from "@app/lib/common_data";

import ExcelDownloadBtn from "@app/components/Stat/ExcelDownloadBtn";
import { SelectStatPeriod, getDefinedPeriod } from "@app/components/Stat/SelectStatPeriod/index";

import ViewSubOption from "./components/ViewSubOption";
import ContentBranch from "./Branch/ContentBranch";
import ContentNursery from "./Branch/ContentNursery";

class StatBooksBranch extends Component {
    constructor(props) {
        super(props);
        const isRoleBranch = util.isRoleBranch();
        var branchId = 0;
        var branchName = "";
        var statMinDate = new Date("2020-06-01"); // 서비스 시작일
        this.showLastYearShortCut = true;
        if (isRoleBranch) {
            const logInfo = util.getLoginBranchInfo();
            branchName = logInfo.name;
        }
        const periodInit = getDefinedPeriod("week", "current");

        this.state = {
            isRoleBranch: isRoleBranch,
            branchId: branchId,
            branchName: branchName,
            branchList: [],
            selectBranch: branchId > 0,
            nurseryId: 0,
            nurseryName: null,
            statPeriod: {
                startDate: format(periodInit.startDate, "yyyy-MM-dd"),
                endDate: format(periodInit.endDate, "yyyy-MM-dd"),
                type: "week",
            },
            statMinDate: statMinDate,
            viewCategory: "branch",
            viewCategorySub: null,
            viewCategorySubOption: null,
            showViewCategorySubOption: false,
            defaultCategorySubOption: branchName,
            selectedCategorySubOption: branchName,
            selectedCategorySubOptionMeta: null,
            mainStat: false,
        };
        this.childView = React.createRef();
    }

    componentDidMount() {
        if (!this.state.isRoleBranch) {
            this.getBranchList();
        }
    }

    getBranchList = () => {
        this.setState(
            {
                selectBranch: false,
            },
            function () {
                commonData.getBranchList(axios, (err, branchList) => {
                    if(err) {
                        console.log(err);
                        alert("지사 목록을 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                    } else {
                        this.setState({
                            branchList: branchList,
                            selectBranch: true,
                            branchId: branchList[0].id,
                        });
                    }
                });
            }
        );
    };
    changeBranch = (value) => {
        var branchId = value;
        var branchName = "";

        var branchList = this.state.branchList;
        for (var i = 0; i < branchList.length; i++) {
            var branch = branchList[i];
            if (Number(branch.id) === Number(branchId)) {
                branchName = branch.name;
            }
        }

        this.setState({
            branchId: branchId,
            branchName: branchName,
            viewCategorySub: null,
            nurseryId: null,
            nurseryName: null,
            viewCategorySubOption: null,
            defaultCategorySubOption: branchName,
            selectedCategorySubOption: branchName,
            selectedCategorySubOptionMeta: null,
            mainStat: false,
        });
    };

    onPeriodChangeHandler = (startDate, endDate, periodType) => {
        this.setState(
            {
                statPeriod: {
                    startDate: format(startDate, "yyyy-MM-dd"),
                    endDate: format(endDate, "yyyy-MM-dd"),
                    type: periodType,
                },
                mainStat: false,
            },
            () => {}
        );
    };

    updateMainStat = (data) => {
        this.setState({ mainStat: data });
    };

    onSelectNursery = (nurseryId, nurseryName, branchId, branchName) => {
        if (branchId && branchName) {
            this.setState({ nurseryId, nurseryName, branchId, branchName, viewCategorySub: "nursery" }, () => {
                //window.history.pushState(null, '', './class/sub');
            });
        } else {
            this.setState({ nurseryId, nurseryName, viewCategorySub: "nursery" }, () => {
                //window.history.pushState(null, '', './class/sub');
            });
        }
    };

    updateViewSubOption = (data, defaultSelected = this.branchName) => {
        this.setState({
            viewCategorySubOption: data,
            defaultCategorySubOption: defaultSelected,
            selectedCategorySubOption: defaultSelected,
        });
    };

    onViewSubOptionSelected = (selected, metaData) => {
        this.setState({ selectedCategorySubOption: selected, selectedCategorySubOptionMeta: metaData }, () => {
            //window.history.pushState(null, '', './sub/option');
        });
    };

    onViewBack = () => {
        if (this.state.viewCategorySub) {
            this.setState({ viewCategorySub: null, viewCategorySubOption: null, nurseryId: null, nurseryName: null });
        } else {
            this.setState({ viewCategorySub: null, nurseryId: null, nurseryName: null });
            return false;
        }
    };

    changePage = (e) => {
        const urlBase = process.env.REACT_APP_BASE_URL;
        document.location.href = urlBase + "/stat/books/" + e;
    }

    render() {
        const {
            isRoleBranch,
            statPeriod,
            statMinDate,
            branchList,
            branchId,
            branchName,
            nurseryId,
            nurseryName,
            className,
            viewCategory,
            viewCategorySub,
            viewCategorySubOption,
            showViewCategorySubOption,
            defaultCategorySubOption,
            selectedCategorySubOption,
            mainStat,
        } = this.state;
        return (
            <div className="dashboard-wrapper">
                <div className="dashboard-ecommerce">
                    <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                        <div className="row">
                            <h2 className="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-4pageheader-title">
                                별별책방
                                {nurseryName ? ` - ${nurseryName}` : ""}
                            </h2>
                            {!isRoleBranch && (<div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 float-right">
                                <select className="form-control form-control-lg" name="month" value={"branch"} onChange={(e) => this.changePage(e.target.value)} style={{ fontSize: "1.3em" }}>
                                    <option value="hq">본사</option>
                                    <option value="branch">지사</option>
                                </select>
                            </div>)}
                        </div>
                    </div>
                    <div className="container-fluid dashboard-content">
                        <div className="row mb-3">
                            {viewCategorySub && (
                                <div className="col-xl-1 col-lg-3 col-md-3 col-sm-3 col-4" style={{ minWidth: "59px", maxWidth: "59px", marginTop: "-5px" }}>
                                    <button
                                        className="btn btn-default"
                                        style={{
                                            border: "0px",
                                            width: "44px",
                                        }}
                                        type="button"
                                        onClick={this.onViewBack}
                                    >
                                        <span className="fa fa-lg fa-chevron-left" aria-hidden="true" />
                                    </button>
                                </div>
                            )}
                            <div className="col-xl-3 col-lg-9 col-md-9 col-sm-9 col-8">
                                <SelectStatPeriod
                                    id="select-stat-period"
                                    minDate={statMinDate}
                                    showLastYearShortCut={this.showLastYearShortCut}
                                    onPeriodChangeHandler={this.onPeriodChangeHandler.bind(this)}
                                />
                            </div>
                            {!isRoleBranch && !viewCategorySub && (
                                <>
                                    <div className="col-xl-2 col-lg-6 col-md-6 col-sm-12 col-12">
                                        <ViewSubOption
                                            data={branchList}
                                            defaultSelected={branchList && branchList.length > 0 ? branchList[0].id : ""}
                                            showViewCategorySubOption={true}
                                            onOptionSelect={this.onViewSubOptionSelected.bind(this)}
                                            selected={selectedCategorySubOption}
                                        />
                                    </div>
                                    {viewCategorySub && (
                                        <>
                                            <div className="col-xl-2 col-lg-6 col-md-6 col-sm-12 col-12">
                                                <div className="row align-items-center h-100">
                                                    <div className="col">
                                                        <ViewSubOption
                                                            data={viewCategorySubOption}
                                                            defaultSelected={defaultCategorySubOption}
                                                            showViewCategorySubOption={showViewCategorySubOption}
                                                            selected={selectedCategorySubOption}
                                                            onOptionSelect={this.onViewSubOptionSelected.bind(this)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                            {isRoleBranch && (
                                <>
                                    <div className="col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12">
                                        <ViewSubOption
                                            data={viewCategorySubOption}
                                            defaultSelected={defaultCategorySubOption}
                                            selected={selectedCategorySubOption}
                                            onOptionSelect={this.onViewSubOptionSelected.bind(this)}
                                        />
                                    </div>
                                </>
                            )}
                            <ExcelDownloadBtn view={this.childView} statPeriod={statPeriod} />
                        </div>
                        <div className="row">
                            <div className="col-12">
                                {!viewCategorySub ? (
                                    <ContentBranch
                                        isRoleBranch={isRoleBranch}
                                        branchList={branchList}
                                        branchName={branchName}
                                        nurseryId={nurseryId}
                                        nurseryName={nurseryName}
                                        statPeriod={statPeriod}
                                        viewCategorySub={viewCategorySub}
                                        selectedCategorySubOption={selectedCategorySubOption}
                                        updateViewSubOption={this.updateViewSubOption.bind(this)}
                                        onViewSubOptionSelected={this.onViewSubOptionSelected.bind(this)}
                                        onSelectNursery={this.onSelectNursery.bind(this)}
                                        updateMainStat={this.updateMainStat.bind(this)}
                                        statAll={mainStat}
                                        ref={this.childView}
                                    />
                                ) : (
                                    <ContentNursery
                                        nurseryId={nurseryId}
                                        branchList={branchList}
                                        branchName={branchName}
                                        nurseryName={nurseryName}
                                        statPeriod={statPeriod}
                                        viewCategorySub={viewCategorySub}
                                        updateViewSubOption={this.updateViewSubOption.bind(this)}
                                        ref={this.childView}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default StatBooksBranch;
